import React from 'react';
import { Link } from 'react-router-dom';
import { Translate } from 'core/translate';
import { SvgIcon } from 'core/icons';

const SubgroupHeader = ({ title, to, analytics }) => {
  const className = `summary-option-panel__subheader hide-for-print ${
    title ? 'summary-option-panel__subheader--with-title' : ''
  }`;
  return (
    <div className={className}>
      {title ? (
        <span className="summary-option-panel__title">{title}</span>
      ) : null}
      <Link
        to={to}
        className="button button--flex button--link button--summary-link button--without-padding stat-text-link"
        data-dtm={analytics}>
        <SvgIcon name="pencil" className="button__icon" />
        <span className="button__text">
          <Translate value="edit" />
        </span>
      </Link>
    </div>
  );
};

export default SubgroupHeader;
